<div class="toastr-wrapper" #toastrWrapperElement>
  <div
    class="toastr-status"
    [ngClass]="[statusClassName, borderShape]"
    (click)="clickEvent($event)"
  >
    <img
      *ngIf="statusClassName === 'impeditivo'"
      src="assets/images/error.svg"
      alt="Toastr Icon"
      class="toastr-icon"
    />

    <img
      *ngIf="statusClassName === 'informativo'"
      src="assets/images/informativo.svg"
      alt="Toastr Icon"
      class="toastr-icon"
    />

    <span
      class="message-status"
      [ngClass]="mensagemClassName"
      [innerHTML]="toastrInfo?.mensagem || ''"
    ></span>
  </div>
</div>
